export default (phoneNumber: string | null | undefined) => {
  if (!phoneNumber) return '';

  let parsedPhoneNumber = phoneNumber.replaceAll(' ', '');

  if (parsedPhoneNumber.startsWith('0')) {
    parsedPhoneNumber = parsedPhoneNumber.replace('0', '+31');
  }

  return parsedPhoneNumber;
};
